import {LABELS} from '../../../shared/labels/Labels';
import {SignupFormProps} from '../SignupForm/SignupForm';
import {
  StyledCheckboxField,
  StyledTermsAndConditionsTextWrapper,
} from '../styled';
import {useGlobalization} from '@planday-corp/globalization';
import Link from '@planday-corp/ui/actions/Link';
import Text from '@planday-corp/ui/text/Text';
import React from 'react';

export interface TermsAndConditionsProps
  extends Pick<
    SignupFormProps,
    'isLoading' | 'hasAcceptedTerms' | 'hasSaved' | 'actions'
  > {
  isCountryCodeAU: boolean;
}

function TermsAndConditions({
  isCountryCodeAU,
  isLoading,
  hasSaved,
  hasAcceptedTerms,
  actions,
}: TermsAndConditionsProps) {
  const {i18n} = useGlobalization();

  return (
    <>
      <StyledCheckboxField
        name="terms"
        isDisabled={isLoading}
        value={hasAcceptedTerms}
        wrap
        checkboxLabel={i18n.t(LABELS.termsAndConditionsCheckboxText)}
        onChange={(value: boolean) =>
          actions.receive({hasAcceptedTerms: value})
        }
        error={
          hasSaved && !hasAcceptedTerms
            ? {
                term: 'CommonTerms.Generic_RequiredField',
                fallback: 'Required field',
              }
            : undefined
        }
      />

      <StyledTermsAndConditionsTextWrapper>
        <Text size="body">
          {i18n.t(LABELS.seeAllDocuments)}{' '}
          <Link
            target="_blank"
            title={i18n.t(LABELS.termsAndConditionsAriaTitle)}
            href={
              isCountryCodeAU
                ? 'https://www.planday.com/au/legal/'
                : i18n.t(LABELS.termsAndConditionsLink)
            }
          >
            {i18n.t(LABELS.here)}
          </Link>
        </Text>
      </StyledTermsAndConditionsTextWrapper>
    </>
  );
}

export default TermsAndConditions;
